<template>
  <div class="wrapper">
    <div class="navBar">
      <div class="navBox">
        <Icon type="ios-document-outline" />
        考试份数({{ total.examinationCount }})
      </div>
      <div class="navBox">
        <Icon type="md-create" />
        考试次数({{ total.testCount }})
      </div>
      <div class="navBox">
        <Icon type="md-apps" />
        分类({{ total.classification }})
      </div>
      <div class="navBox">
        <Icon type="md-filing" />
        归档试卷({{ total.archive }})
      </div>
    </div>

    <div class="twoSideBox">
      <div class="leftBox" ref="treeBox" style="width: 200px">
        <h2 class="centerFont">试卷分类列表</h2>
        <div class="treeBox">
          <mytree
            :searchInput="true"
            :treeData="examinationType"
            @eventUp="treeEvent"
            @dataUpdate="examinationTypeUpdate"
          ></mytree>
        </div>
      </div>
      <div class="slider" @mousedown="sliderClick"></div>
      <div class="rightBox">
        <div class="tableContainer">
          <div class="tableTitle">所有试卷</div>
          <div class="tableContent">
            <div class="actBar">
              <div>
                <el-button
                  icon="el-icon-plus"
                  size="small"
                  type="primary"
                  @click="goTo('newExamination')"
                  >新建试卷</el-button
                >
                <!-- <el-button type="primary" size="small" plain
                  >一周考试详情</el-button
                > -->
                <el-button
                  type="primary"
                  size="small"
                  :disabled="!paperIfSelectSome"
                  @click="examMoveData.ifShow = true"
                  plain
                  >移动到分类</el-button
                >
                <el-button
                  icon="md-filing"
                  size="small"
                  type="primary"
                  :disabled="!paperIfSelectSome"
                  plain
                  @click="filePaper"
                  >归档</el-button
                >
                <el-button
                  icon="el-icon-delete-solid"
                  type="danger"
                  size="small"
                  :disabled="!paperIfSelectSome"
                  @click="deletePaperList"
                  plain
                  >删除试卷</el-button
                >
              </div>

              <div>
                <el-input
                  placeholder="请输入试卷名"
                  v-model="searchCondition.queryExamName"
                  style="width: 200px"
                  size="small"
                >
                  <el-button
                    icon="el-icon-search"
                    slot="append"
                    @click="searchPaperByName"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <div class="filterBar">
              <el-checkbox :value="paperIfSelectAll" @change="paperSelectAll"
                >全选</el-checkbox
              >
              <el-pagination
                layout="prev, pager, next"
                :current-page.sync="searchCondition.jumpPage"
                @current-change="searchPaperList"
                :total="searchCondition.total"
              >
              </el-pagination>

              <div class="testStatusBar">
                <div
                  :class="[
                    'testStatus',
                    { active: searchCondition.status == '' },
                  ]"
                  @click="changeStatus('')"
                >
                  所有
                </div>
                <div
                  :class="[
                    'testStatus',
                    { active: searchCondition.status == 4 },
                  ]"
                  @click="changeStatus(4)"
                >
                  已考完
                </div>

                <div
                  :class="[
                    'testStatus',
                    { active: searchCondition.status == 3 },
                  ]"
                  @click="changeStatus(3)"
                >
                  考试中
                </div>
                <div
                  :class="[
                    'testStatus',
                    { active: searchCondition.status == 2 },
                  ]"
                  @click="changeStatus(2)"
                >
                  未开始
                </div>
                <div
                  :class="[
                    'testStatus',
                    { active: searchCondition.status == 1 },
                  ]"
                  @click="changeStatus(1)"
                >
                  草稿
                </div>
              </div>
            </div>
            <div class="contentBox">
              <div
                class="contentBar"
                v-for="item in paperList"
                :key="'paper' + item.id"
              >
                <el-checkbox v-model="item.choose"></el-checkbox>
                <img class="tableImg" :src="item.imageUrl" alt />
                <div class="detailBox">
                  <div class="titleBar" @click="showShareUrl(item)">
                    {{ item.exName }}
                    <span
                      class="label"
                      :style="{ background: statusMap[item.status].color }"
                      >{{ statusMap[item.status].label }}</span
                    >
                    <el-button
                      size="small"
                      type="primary"
                      :plain="item.top == 1"
                      @click.stop="topPaper(item)"
                      round
                      >{{ item.top ? "取消置顶" : "置顶" }}</el-button
                    >
                    &emsp;
                    <div @click.stop="">
                      <el-switch
                        v-model="item.appletShow"
                        active-text="小程序展示"
                        inactive-text="小程序不展示"
                        :active-value="1"
                        :inactive-value="0"
                        @change="(value) => miniappEdit(item, value)"
                      >
                      </el-switch>
                    </div>
                  </div>
                  <div class="settingBar">
                    {{ item.groupName }}|{{
                      consituteList[item.constituteEx - 1]
                    }}试题考试|总分{{ item.score }}分|共{{
                      item.questionNum
                    }}道题|限制{{ item.exDuration }}分钟|指定组：勤博内部|
                  </div>
                  <div class="actBar">
                    <el-button size="small" @click="paperStatusEdit(item)"
                      >{{
                        ["", "发布", "开始", "停止", "重新开始"][item.status]
                      }}考试</el-button
                    >

                    <el-button
                      size="small"
                      @click="goTo('questionEdit', item, 'examinationEdit')"
                      >管理试题</el-button
                    >
                    <el-button
                      size="small"
                      @click="goTo('paperAnalysis', item, 'paperAnalysis')"
                      >统计分析</el-button
                    >
                    <el-button
                      size="small"
                      @click="goTo('paperDataEdit', item, 'examinationEdit')"
                      >考试编辑</el-button
                    >
                    <el-button
                      size="small"
                      @click="goTo('recordList', item, 'recordList')"
                      >考试记录</el-button
                    >
                    <el-button
                      size="small"
                      @click="goTo('paperDetail', item, 'examEdit')"
                      >考试详情</el-button
                    >
                    <el-button
                      size="small"
                      @click="goTo('manualFaceCheck', item, 'manualFaceCheck')"
                      >人脸识别人工通道</el-button
                    >
                    <el-button
                      size="small"
                      @click="
                        goTo('examinationSetting', item, 'examinationEdit')
                      "
                      >设置</el-button
                    >
                    <el-button size="small">更多</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="请选择试卷分类"
      :visible.sync="examMoveData.ifShow"
      width="50%"
      :append-to-body="true"
    >
      <mytree :treeData="examinationType" @eventUp="examGroupEvent"></mytree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="examMoveData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="examGroupConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择时间"
      :visible.sync="paperOpenSetIfShow"
      width="50%"
      :append-to-body="true"
    >
      <el-radio v-model="paperOpenSet.validDateSet" :label="2"
        >永久有效</el-radio
      ><br /><br />
      <el-radio v-model="paperOpenSet.validDateSet" :label="1"
        >限时开放<br />
        <el-date-picker
          @change="
            (changeData) =>
              ([paperOpenSet.startTime, paperOpenSet.endTime] = changeData)
          "
          size="mini"
          v-model="paperOpenSet.upToDate"
          v-show="paperOpenSet.validDateSet == 1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paperOpenSetIfShow = false">取 消</el-button>
        <el-button type="primary" @click="editPaperOpenSet">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="shareItem.exName"
      :visible.sync="shareItemIfShow"
      width="70%"
      :append-to-body="true"
    >
      <div class="shareBox">
        <div class="shareContent">
          <div class="title">方式一：复制链接考试</div>
          <el-input disabled v-model="shareExamUrl" class="urlInput"></el-input>
          <div class="midFont" v-if="shareItem.accessCode">
            访问码：{{ shareItem.accessCode }}
          </div>
          <div class="actBar">
            <el-button type="primary" size="mini" @click="copyText"
              >复制链接</el-button
            >
            <el-button type="primary" size="mini" @click="jumpTo" plain
              >直接打开</el-button
            >
          </div>
        </div>
        <div class="shareContent">
          <div class="title">方式二：二维码分享</div>
          <!-- <el-input disabled v-model="shareExamUrl"></el-input> -->
          <div class="centerFont bigFont">{{ shareItem.exName }}</div>
          <vue-qr
            :text="shareExamUrl"
            id="qrcodeImg"
            ref="qrcodeImg"
            style="display: block; margin: auto"
          ></vue-qr>
          <div class="greyFont centerFont">把二维码分享给您的学生</div>

          <div class="actBar">
            <el-button type="primary" size="mini" @click="downloadQrcode"
              >下载二维码</el-button
            >
          </div>
        </div>
        <!-- <div class="shareContent">
          <div class="title">方式三：小程序分享</div>
          <el-input disabled v-model="shareItem.url"></el-input>
          <div class="greyFont">把小程序二维码分享给您的学生</div>
          <div class="actBar">
            <el-button type="primary" size="mini">下载二维码</el-button>
          </div>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getExaminationType,
  renameExaminationType,
  deleteExaminationType,
  appendExaminationType,
  moveExaminationType,
  deletePaperList,
  getPaperList,
  filePaper,
  editPaper,
  paperStatusEdit,
  movePaperGroup,
} from "@/api/examination/examination.js";
import vueQr from "vue-qr";
import { Base64 } from "@/libs/js/base64.js";

import mytree from "@/component/tree/mytree.vue";
export default {
  components: { mytree, vueQr },
  props: {},
  data() {
    return {
      paperList: [],
      split1: 0.2,
      shareItemIfShow: false,
      shareItem: "",
      total: {
        examinationCount: 0,
        testCount: 0,
        classification: 0,
        archive: 0,
      },
      searchCondition: {
        groupId: 0,
        status: "",
        pageSize: 10,
        jumpPage: 1,
        total: 0,
        queryExamName: "",
      },
      examinationType: [],
      buttonProps: {
        type: "default",
        size: "small",
      },
      single: false,
      paperOpenSetIfShow: false,
      paperOpenSet: {
        startTime: "",
        endTime: "",
        validDateSet: "",
        upToDate: "",
      },
      examMoveData: {
        ifShow: false,
        chosenGroupId: 0,
      },
      examGroupChooseIfShow: false,
      statusMap: {
        1: { label: "草稿", color: "#ccc" },
        2: { label: "未开始", color: "#efd07c" },
        3: { label: "考试中", color: "#ec8472" },
        4: { label: "已考完", color: "#92cb7b" },
      },
      consituteList: ["固定", "随机", "固定+随机"],
      Base64: new Base64(),
    };
  },
  watch: {},
  computed: {
    paperIfSelectAll() {
      return this.paperList.every((item) => item.choose);
    },
    paperIfSelectSome() {
      return this.paperList.some((item) => item.choose);
    },
    shareExamUrl() {
      let query = this.Base64.encode(`examId-${this.shareItem.id}`);
     // let host = "xktest.cbstudy.com/exam";
        let host = "xkptweb.yukonsys.com.cn/exam";
      // document.location.host.indexOf("test") > -1
      //   ? "testxk.cbstudy.com/exam"
      //   : "exam.cbstudy.com";
      return `https://${host}/#/?${query}`;

      // return `https:///#/?${query}`;
    },
  },
  methods: {
    examGroupEdit() {},
    examGroupEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameExaminationType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
              sort:eventDetail.sort,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteExaminationType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendExaminationType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
              sort:eventDetail.sort,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveExaminationType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        case "select":
          this.examMoveData.chosenGroupId = eventDetail.value.id;
          // console.log(eventDetail);
          break;
        default:
          break;
      }
    },
    examinationTypeUpdate(newExaminationTypeUpdate) {
      this.$set(this.$data, "examinationType", newExaminationTypeUpdate);
    },
    examGroupConfirm() {
      movePaperGroup({
        newGroupId: this.examMoveData.chosenGroupId,
        idList: this.paperList
          .filter((paper) => paper.choose)
          .map((item) => item.id),
      }).then((data) => {
        this.$message.success("移动成功");
        this.examMoveData.ifShow = false;
        this.searchPaperList();
      });
    },
    treeEvent(eventDetail, data) {
      console.log(eventDetail, data);
      switch (eventDetail.type) {
        case "select":
          if (eventDetail.value.id !== this.searchCondition.groupId) {
            this.searchCondition.jumpPage = 1;
            this.searchCondition.groupId = eventDetail.value.id;
            this.searchPaperList();
          }
          break;
        case "rename":
          renameExaminationType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
              sort:eventDetail.sort,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteExaminationType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendExaminationType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
              sort:eventDetail.sort,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveExaminationType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        default:
          break;
      }
    },
    goTo(type, item, routeName) {
      switch (type) {
        case "newExamination":
          this.$router.push({ name: "examinationEdit", params: {} });
          break;
        case "paperDataEdit":
          this.$router.push({
            name: routeName,
            query: { id: item.id, ifEdit: 1 },
          });
          break;
        case "questionEdit":
          this.$router.push({
            name: routeName,
            query: { id: item.id, ifEdit: 2 },
          });
          break;
        case "paperAnalysis":
          this.$router.push({
            name: routeName,
            query: { id: item.id },
          });
          break;
        case "examinationSetting":
          this.$router.push({
            name: routeName,
            query: { id: item.id, ifEdit: 3 },
          });
          break;
        case "recordList":
          this.$router.push({
            name: routeName,
            query: { id: item.id },
          });
          break;
        case "manualFaceCheck":
          this.$router.push({
            name: routeName,
            query: { item: JSON.stringify(item) },
          });
          break;
        default:
          this.$router.push({
            name: routeName,
            query: { id: item.id },
          });
          break;
      }
    },
    paperStatusEdit(item) {
      switch (item.status) {
        case 1:
          paperStatusEdit({ examId: item.id, isRelease: true }).then(
            (data) => {
              this.$message.success("发布成功");
              this.searchPaperList();
            },
            (err) => {
              this.$message.error(err);
            }
          );
          break;
        case 3:
          paperStatusEdit({ examId: item.id, validDateSet: 3 }).then(
            (data) => {
              this.$message.success("停止成功");
              this.searchPaperList();
            },
            (err) => {
              this.$message.error(err);
            }
          );
          break;

        case 2:
          Object.assign(this.paperOpenSet, {
            examId: item.id,
            upToDate: [item.startTime, item.endTime],
            startTime: item.startTime,
            endTime: item.endTime,
            validDateSet: item.validDateSet,
          });
          this.paperOpenSetIfShow = true;
          break;
        case 4:
          Object.assign(this.paperOpenSet, {
            examId: item.id,
            upToDate: [item.startTime, item.endTime],
            startTime: item.startTime,
            endTime: item.endTime,
            validDateSet: item.validDateSet,
          });
          this.paperOpenSetIfShow = true;
          break;
        default:
          break;
      }
    },
    editPaperOpenSet() {
      paperStatusEdit(this.paperOpenSet).then((data) => {
        this.$message.success("修改成功");
        this.searchPaperList();
        this.paperOpenSetIfShow = false;
      });
    },
    showShareUrl(item) {
      console.log(item);
      this.shareItem = item;
      this.shareItemIfShow = true;
    },

    examinationTypeInit() {
      this.searchPaperList();
      getExaminationType().then((data) => {
        data.groupNodeList.forEach(function treeMaker(item) {
          item.expand = false;
          item.contextmenu = true;
          if (item.children && item.children.length > 0) {
            item.children.forEach((nextItem) => treeMaker(nextItem));
          }
        });
        data.groupNodeList.unshift({
          id: 0,
          title: "所有分类",
          parent: 0,
          children: [],
        });
        this.examinationType = data.groupNodeList;
      });
    },
    searchPaperList() {
      getPaperList(this.searchCondition).then((data) => {
        if (!Array.isArray(data.respList)) {
          data.respList = [];
        }
        data.respList.forEach((item) => (item.choose = false));
        this.paperList = data.respList;
        this.searchCondition.total = data.total;
        Object.assign(this.total, data);
      });
    },
    searchPaperByName() {
      console.log(this.searchCondition);
      this.searchCondition.jumpPage = 1;
      this.searchPaperList();
    },
    topPaper(item) {
      editPaper({ examId: item.id, top: item.top ? 0 : 1 }).then((data) => {
        console.log(data);
        this.$message.success(item.top ? "取消" : "" + "置顶成功");
        this.searchPaperList();
      });
    },
    miniappEdit(item, value) {
      editPaper({ examId: item.id, appletShow: value }).then((data) => {
        this.$message.success(value ? "小程序显示成功" : "小程序隐藏成功");
        this.searchPaperList();
      });
    },
    filePaper() {
      let deleteList = this.paperList.filter((item) => item.choose);
      this.$confirm(
        "此操作将归档" + deleteList.length + "张试卷, 是否继续?",
        "归档确认",
        {
          confirmButtonText: "归档",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      ).then(() => {
        filePaper({
          ids: deleteList.map((item) => item.id).toString(),
        }).then(() => {
          this.searchPaperList();
          this.$message({
            type: "success",
            message: "归档成功!",
          });
        });
      });
    },
    deletePaperList() {
      let deleteList = this.paperList.filter((item) => item.choose);
      if (deleteList.length == 0) {
        return;
      }
      this.$confirm(
        "此操作将删除" + deleteList.length + "张试卷, 是否继续?",
        "删除确认",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      ).then(() => {
        deletePaperList({
          ids: deleteList.map((item) => item.id).toString(),
        }).then(() => {
          this.searchPaperList();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });
    },
    changeStatus(status) {
      if (status == this.searchCondition.status) {
        return;
      }
      Object.assign(this.searchCondition, { status: status, jumpPage: 1 });
      this.searchPaperList();
    },
    paperSelectAll(data) {
      if (this.paperList.some((item) => item.choose)) {
        this.paperList.forEach((item) => (item.choose = false));
      } else {
        this.paperList.forEach((item) => (item.choose = true));
      }
    },
    downloadQrcode: function (imgsrc, name) {
      var image = new Image();

      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => {
        let fontLimitPerLine = parseInt((image.width + 100) / 24);
        let exNameList = [...this.shareItem.exName],
          textList = [],
          perText = [],
          textLength = 0;
        exNameList.forEach((item) => {
          if (item.charCodeAt > 255) {
            textLength += 2;
          } else {
            textLength++;
          }
          perText.push(item);
          if (textLength >= fontLimitPerLine) {
            textList.push(perText.join(""));
            perText = [];
            textLength = 0;
          }
        });
        textList.push(perText.join(""));
        //试卷名分割

        var canvas = document.createElement("canvas");
        canvas.width = image.width + 100;
        canvas.height = image.height + 32 * (textList.length + 2);
        var context = canvas.getContext("2d");

        context.font = " 24px Arial";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillStyle = "#000";

        textList.forEach((item, index) => {
          context.fillText(item, canvas.width / 2, index * 32 + 20);
        });

        console.log(this.shareItem.exName.length, canvas.width);
        context.fillText(
          `访问码：${this.shareItem.accessCode}`,
          canvas.width / 2,
          (textList.length + 1) * 32
        );
        context.drawImage(
          image,
          50,
          (textList.length + 2) * 32,
          image.width,
          image.height
        ); //image.width, image.height

        var url = canvas.toDataURL(); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      // image.src = document.getElementById("qrcodeImg").src;
      image.src = this.$refs.qrcodeImg.$el.src;
    },
    copyText() {
      console.log(this.shareExamUrl);
      var input = document.createElement("input");
      if (this.shareItem.accessCode) {
        input.value =
          this.shareExamUrl + "  访问码：" + this.shareItem.accessCode;
      } else {
        input.value = this.shareExamUrl;
      }
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    jumpTo() {
      window.open(this.shareExamUrl, "_blank");
    },
    sliderClick(event) {
      let widthReduce = document.body.scrollWidth * 0.135;
      let widthMin = widthReduce + 150;
      document.onmousemove = (event) => {
        if (event.screenX > widthMin) {
          this.$refs.treeBox.style.width = event.screenX - widthReduce + "px";
        }
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
  created() {},
  mounted() {
    this.examinationTypeInit();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  // min-width: 1000px;
  // background: #fff;
  font-size: 12px;
  // margin: 15px;
  .twoSideBox {
    display: flex;
    position: relative;
    // max-height: 80vh;
    margin-top: 10px;
    .leftBox {
      padding-top: 5px;
      // width: 200px;
      background: #fff;
    }
    .slider {
      width: 8px;
      background: rgba(0, 0, 0, 0.1);
      cursor: w-resize;
    }
    .rightBox::-webkit-scrollbar {
      display: none;
    }
    .rightBox {
      flex: 1;
      // padding: 0 15px;
      min-height: 30vh;
      //   max-height: 80vh;
      overflow: scroll;

      .tableContainer {
        border: 1px solid #ccc;
        border-radius: 0 5px 5px 0;

        .tableTitle {
          color: #000;
          font-weight: bold;
          font-size: 1.4rem;
          padding-left: 10px;
          border-bottom: 1px solid #ccc;
          padding: 10px;
          background: #fff;
          border-radius: 0 5px 0 0;
        }
        .tableContent {
          padding: 10px;
          background: #fff;
          border-radius: 0 0 5px 0;
          .actBar {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .filterBar {
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-between;
            .testStatusBar {
              display: flex;

              .testStatus {
                padding: 3px 8px;
                line-height: 20px;
                border: 1px solid #ccc;
                margin-left: -1px;
                min-width: 50px;
                text-align: center;
              }

              .testStatus:hover {
                opacity: 0.8;
              }
              .active {
                border-color: #618afd;
                color: #618afd;
                z-index: 1;
              }
              .testStatus:first-child {
                border-radius: 13px 0 0 13px;
              }
              .testStatus:last-child {
                border-radius: 0 13px 13px 0;
              }
            }
          }
          .contentBox {
            border: 1px solid #ccc;
            padding: 20px;

            .contentBar {
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex: 1;
              margin-bottom: 20px;
              // border-bottom: 1px solid #ccc;
              border: 1px solid #ccc;
              padding: 30px 10px;
              border-radius: 4px;
              .el-checkbox {
                margin-right: 10px;
              }
              .tableImg {
                width: 140px;
              }
              .detailBox {
                flex: 1;
                margin-left: 20px;
                .titleBar {
                  font-size: 1.6rem;
                  font-weight: bold;
                  display: flex;
                  cursor: pointer;
                  align-items: center;
                  .label {
                    font-weight: normal;
                    font-size: 13px;
                    color: #fff;
                    background: red;
                    padding: 0px 7px;
                    margin: 0 10px;
                    border-radius: 9px !important;
                    vertical-align: top;
                    display: inline-block;
                    cursor: pointer;
                  }
                }
                .settingBar {
                  margin-bottom: 1rem;
                }
              }
              .actBar {
                justify-content: flex-end;
              }
            }
          }
        }
      }
    }
  }
  .navBar {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    background: #fff;
    .navBox {
      display: flex;
      font-size: 1.5rem;
      border-radius: 10px;
      height: 95px;
      width: 22%;
      color: #fff;
      align-items: center;
      justify-content: center;
      i {
        font-size: 2rem;
      }
    }
    .navBox:nth-child(1) {
      background: #63b5ef;
    }
    .navBox:nth-child(2) {
      background: #92cb7b;
    }
    .navBox:nth-child(3) {
      background: #efd07c;
    }
    .navBox:nth-child(4) {
      background: #ec8472;
    }
  }
}
.shareBox {
  display: flex;
  justify-content: space-around;
  background: #f6f8ff;
  padding: 20px 10px;
  .shareContent {
    background: #fff;
    padding: 10px 10px 60px 10px;
    margin: 0 10px;
    flex: 1;
    position: relative;
    .title {
      font-size: 1.05rem;
    }
    .urlInput {
      display: block;
      width: 100%;
    }
    .actBar {
      position: absolute;
      text-align: center;
      bottom: 20px;
      width: 100%;
      left: 0;
    }
    .qrcode {
      width: 170px;
      height: 170px;
      display: block;
      margin: 15px auto;
    }
    .downloadBtn {
    }
  }
}
/deep/ .el-button + .el-button {
  margin-left: 5px;
}
/deep/ .el-checkbox__inner {
  height: 20px;
  width: 20px;
}
/deep/ .el-checkbox__inner::after {
  width: 4px;
  height: 12px;
  left: 6px;
  top: 0;
  border-width: 2px;
}
</style>